import * as i0 from '@angular/core';
import { Component, NgModule } from '@angular/core';
import * as i1 from '@rogers/cdk/common/directives';
import { DirectivesModule } from '@rogers/cdk/common/directives';
import { CommonModule } from '@angular/common';

class TileComponent {
    constructor() { }
    ngOnInit() { }
}
TileComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TileComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TileComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: TileComponent, selector: "ds-tile", ngImport: i0, template: "<div\n  [brClass]=\"[\n    ['ds-corners', '', '', 'ds-corners'],\n    ['', '', 'ds-borders', ''],\n    ['', '', 'ds-brcolor-fog', '']\n  ]\"\n  class=\"ds-tile h-100 ds-bg-body-default ds-shadow ds-no-overflow\"\n>\n  <ng-content></ng-content>\n</div>\n", directives: [{ type: i1.BrandClassDirective, selector: "[brClass]", inputs: ["brClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-tile', styles: [], template: "<div\n  [brClass]=\"[\n    ['ds-corners', '', '', 'ds-corners'],\n    ['', '', 'ds-borders', ''],\n    ['', '', 'ds-brcolor-fog', '']\n  ]\"\n  class=\"ds-tile h-100 ds-bg-body-default ds-shadow ds-no-overflow\"\n>\n  <ng-content></ng-content>\n</div>\n" }]
        }], ctorParameters: function () { return []; } });

class TileModule {
}
TileModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TileModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TileModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TileModule, declarations: [TileComponent], imports: [CommonModule, DirectivesModule], exports: [TileComponent] });
TileModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TileModule, imports: [[CommonModule, DirectivesModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TileModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TileComponent],
                    imports: [CommonModule, DirectivesModule],
                    exports: [TileComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TileComponent, TileModule };
